<template>
	<svg id="active" @click="click" v-if="active" viewBox="0 0 1010 1010" width="25" height="25">
		<rect class="cls-1" x="20" y="20" width="970" height="970" rx="169.46" />
		<rect class="cls-2" x="218.4" y="309.41" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="218.69" y="441.01" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="218.69" y="573.01" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.69" y="309.01" width="428.31" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.33" y="441.01" width="428.31" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.33" y="573.01" width="428.31" height="91.59" rx="21.29" />
	</svg>
	<svg id="inactive" @click="click" viewBox="0 0 1010 1010" width="25" height="25" v-else>
		<rect class="cls-1" x="20" y="20" width="970" height="970" rx="169.46" />
		<rect class="cls-2" x="218.4" y="309.41" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="218.69" y="441.01" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="218.69" y="573.01" width="91.6" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.69" y="309.01" width="428.31" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.33" y="441.01" width="428.31" height="91.59" rx="21.29" />
		<rect class="cls-2" x="338.33" y="573.01" width="428.31" height="91.59" rx="21.29" />
	</svg>
</template>

<script>
	export default {
		name: 'HamburgerSVG',
		props: {
			active: Boolean
		},
		methods: {
			click() {
				this.$emit('click');
			}
		}
	};
</script>

<style scoped lang="scss">
	#active {
		.cls-1 {
			fill: #231e21;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
		.cls-2 {
			fill: #fff;
		}
	}
	#inactive {
		.cls-1 {
			fill: #fff;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
		.cls-2 {
			fill: #231e21;
		}
	}
</style>
